import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import Password from '../password/Password';

const useStyles = makeStyles((theme) => ({
    label: {
        textAlign: 'center'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    titleAppBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    link: {
        marginTop: theme.spacing(2)
    },
    dialog: {
        zIndex: '10000 !important'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function FirstSetup(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [languageApp, setLanguageApp] = React.useState(null);
    const [userId, setUserId] = React.useState('');

    const { openFirstSetup, handleClose, language, userCode } = props;

    useEffect(() => {
        setOpen(openFirstSetup);
    }, [openFirstSetup]);

    useEffect(() => {
        setUserId(userCode);
    }, [userCode]);

    const handleCloseClick = () => {
        handleClose();
    };

    useEffect(() => {
        setLanguageApp(language);
    }, [language]);

    return (
        <div className={classes.label}>
            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition} className={classes.dialog}>
                <div data-id="headerPassword">
                    <AppBar id="appBarTitle" className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBar}>
                                {i18next.t('password:titleFirstSetup')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divRootPassword">
                    <Password userCode={userId} isFirstSetup={true} />
                </div>
            </Dialog>
        </div>
    );
}

export default withNamespaces(['password'], { wait: true })(FirstSetup);